import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  connect() {
    // console.log("Hello, LicensesController!", this.element);
  }

  // Soort abonnement: Werkruimte of Opvragen
  access_type_changed(event) {
    const asStudentInput= document.querySelector('#license_license_details_as_student');
    if (asStudentInput && asStudentInput.checked) {
      // Zet 'Ik ben student' standaard uit als je soort abonnement wijzigt.
      asStudentInput.checked= false;
      asStudentInput.dispatchEvent(new Event('change'));  // Trigger onChange event, alternative for jquery.change()
    }
  }

  // Leeszaal functie?
  as_library_changed(event) {
    // Indien Leeszaal functie wordt aangezet, zorg voor minimaal 2 gebruikers en zet Student optie uit
    const numberOfUsersInput= document.querySelector('#license_license_details_number_of_users');
    const asStudentInput= document.querySelector('#license_license_details_as_student');
    console.log(numberOfUsersInput);
    if (numberOfUsersInput) {
      const number_of_users_qty=numberOfUsersInput.value;

      if (event.currentTarget.checked) {
        // Aantal gebruikers min. 2
        if (number_of_users_qty < 2) numberOfUsersInput.value=2;
        numberOfUsersInput.min=2;
        if (asStudentInput && asStudentInput.checked) {
          asStudentInput.checked= false;
          asStudentInput.dispatchEvent(new Event('change'));  // Trigger onChange event, alternative for jquery.change()
        }
      } else {
        // Reset
        numberOfUsersInput.min=1;
      }
    }

  }
}
